import { render, staticRenderFns } from "./addTemplate.vue?vue&type=template&id=0ab0d3ba"
import script from "./addTemplate.vue?vue&type=script&lang=js"
export * from "./addTemplate.vue?vue&type=script&lang=js"
import style0 from "./addTemplate.vue?vue&type=style&index=0&id=0ab0d3ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports